const ResortFeeInclusionIcon = props => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    fill="#FB923C"
    {...props}
  >
    <path d="M19.7917 14.5834V6.25008C19.7917 5.10425 18.8542 4.16675 17.7083 4.16675H3.12499C1.97916 4.16675 1.04166 5.10425 1.04166 6.25008V14.5834C1.04166 15.7292 1.97916 16.6667 3.12499 16.6667H17.7083C18.8542 16.6667 19.7917 15.7292 19.7917 14.5834ZM10.4167 13.5417C8.68749 13.5417 7.29166 12.1459 7.29166 10.4167C7.29166 8.68758 8.68749 7.29175 10.4167 7.29175C12.1458 7.29175 13.5417 8.68758 13.5417 10.4167C13.5417 12.1459 12.1458 13.5417 10.4167 13.5417ZM23.9583 7.29175V18.7501C23.9583 19.8959 23.0208 20.8334 21.875 20.8334H4.16666V18.7501H21.875V7.29175H23.9583Z" />
  </svg>
)

export default ResortFeeInclusionIcon
